import React from "react";
import Grid, { GridProps } from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";

const useStyles = makeStyles(() => ({
  label: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  grid: {
    padding: "0 !important",
  },
}));

interface IEditorGridProps extends GridProps {
  centerAlign?: boolean;
}

export const EditorGrid = ({
  centerAlign,
  children,
  ...props
}: IEditorGridProps) => {
  const classes = useStyles();
  return (
    <Grid
      className={classNames(classes.grid, centerAlign ? classes.label : "")}
      {...props}
    >
      {children}
    </Grid>
  );
};
